import { faBell, faExclamationTriangle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import React, { useMemo } from 'react';
import { useSections } from '../../context/site-content.context';
import { createElementId } from '../../helpers/content.helper';
import { AlertVariant } from '../../models/component.model';
import { ContentButtonLink } from '../sections/ContentButtonLink';
import { ContentHtml } from '../sections/ContentHtml';
import { Icon } from '../shared/Icon';

interface Props {
    item: AlertVariant;
    variantIndex: number;
}

export const AlertVariantDisplay = ({ item }: Props): React.ReactElement<any, any> | null => {
    const sections = useSections(item.id);

    const icon = useMemo(() => {
        switch (item.options?.alertType) {
            case 'danger':
                return faExclamationTriangle;
            case 'warning':
                return faBell;
            default:
                return faInfoCircle;
        }
    }, [item.options?.alertType]);

    return (
        <div className="content-wrapper-alert mb-5">
            {sections.map((section, index) => {
                const id = createElementId(section.id);

                return (
                    <div
                        id={id}
                        key={index}
                        className="content-width content alert-variant-display"
                    >
                        <div
                            className={`alert alert-${
                                item.options?.alertType || 'info'
                            } align-items-center ${
                                index === item.sectionPriority.length - 1 ? '' : 'mb-2'
                            }`}
                        >
                            <div className="flex-shrink-1">
                                <Icon icon={icon} size="3x" />
                            </div>
                            <div className="flex-grow-1 alert-body">
                                {section.header && <h2>{section.header}</h2>}
                                {section.body && <ContentHtml source={section.body} />}
                                {section.link && (
                                    <div>
                                        <ContentButtonLink
                                            to={section.link.url}
                                            variant={item.options?.alertType}
                                            className="shadow"
                                        >
                                            {section.link.text || section.link.url}
                                        </ContentButtonLink>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
